import React from 'react';
import { Award, ShieldCheck, GraduationCap, Users, Briefcase } from 'lucide-react';
import { TRUST_STATS } from '../data/coursesData';

const iconMap = {
  Award: <Award size={32} color="#D4AF37" />,
  ShieldCheck: <ShieldCheck size={32} color="#D4AF37" />,
  GraduationCap: <GraduationCap size={32} color="#D4AF37" />,
  Users: <Users size={32} color="#D4AF37" />,
  Briefcase: <Briefcase size={32} color="#D4AF37" />
};

export default function TrustBadges() {
  return (
    <section id="accreditations" style={{
      backgroundColor: '#0F2537',
      borderTop: '1px solid rgba(212, 175, 55, 0.3)',
      borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
      padding: '2.5rem 0',
      color: '#FFFFFF'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '2rem',
          alignItems: 'center'
        }}>
          {TRUST_STATS.map((stat, idx) => (
            <div key={idx} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.1rem',
              padding: '0.75rem 1rem',
              borderRadius: '12px',
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255, 255, 255, 0.08)'
            }}>
              <div style={{
                width: '56px',
                height: '56px',
                borderRadius: '14px',
                backgroundColor: 'rgba(212, 175, 55, 0.12)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                {iconMap[stat.icon]}
              </div>
              <div>
                <div style={{
                  fontSize: '1.65rem',
                  fontWeight: 800,
                  color: '#FEF08A',
                  lineHeight: 1.1,
                  letterSpacing: '-0.02em'
                }}>
                  {stat.value}
                </div>
                <div style={{
                  fontSize: '0.85rem',
                  color: '#CBD5E1',
                  fontWeight: 500,
                  marginTop: '0.2rem',
                  lineHeight: 1.3
                }}>
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
